import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { dealBuilderApi } from '../api';
import { useDealBuilderContext } from '../context/DealBuilderContext';
import { collectVariablesForCreateProposal } from 'modules/desking';
import { FinanceProgramFormValues } from 'modules/desking';
import { DeskingSubmitOptions } from 'modules/desking/types';

export const useDeskingFormSync = (
  debouncedFormValues: FinanceProgramFormValues | null,
  dealBuilderDeskingData: Pick<
    DeskingSubmitOptions,
    'builder' | 'pricing' | 'productsConfigInMenu' | 'commonProductsConfiguration'
  > & { isProposalDataLoaded: boolean },
  hasSavedDeskingData: boolean
) => {
  const { vo, activeEntity } = useDealBuilderContext();
  const [updateProposal] = useMutation(dealBuilderApi.updateProposal);

  useEffect(() => {
    if (
      !debouncedFormValues ||
      (hasSavedDeskingData && !dealBuilderDeskingData.isProposalDataLoaded) ||
      !activeEntity?.proposalId ||
      !vo?.vendorOpportunityId
    )
      return;

    const { input } = collectVariablesForCreateProposal({
      isDraft: true,
      pricing: dealBuilderDeskingData.pricing,
      formData: debouncedFormValues,
      menuByTerms: dealBuilderDeskingData.builder,
      productsConfigInMenu: dealBuilderDeskingData.productsConfigInMenu,
      commonProductsConfiguration: dealBuilderDeskingData.commonProductsConfiguration,
      voId: vo.vendorOpportunityId,
    });

    updateProposal({
      variables: {
        id: activeEntity.proposalId,
        fieldsObj: { settings: input.settings },
      },
    });
  }, [debouncedFormValues, dealBuilderDeskingData, activeEntity, vo, updateProposal]);
};
